import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";
import { api, errMsg, formatDate } from "@/lib/api";

const TABS = [["pending", "En attente"], ["approved", "Approuvés"], ["rejected", "Rejetés"]];

export default function CommentsManager() {
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/comments", { params: { status } }).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))), [status]);
  useEffect(() => { load(); }, [load]);

  const setS = async (id, s) => { try { await api.put(`/admin/comments/${id}`, { status: s }); toast.success("Commentaire mis à jour"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (id) => { try { await api.delete(`/admin/comments/${id}`); toast.success("Supprimé"); load(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <div data-testid="comments-manager">
      <h1 className="font-heading text-3xl font-black mb-1">Commentaires</h1>
      <p className="text-zinc-500 text-sm mb-6">Modérez les réactions des lecteurs avant publication.</p>
      <div className="flex gap-1 mb-4">{TABS.map(([k, l]) => <button key={k} data-testid={`comments-tab-${k}`} onClick={() => setStatus(k)} className={`px-4 py-2 text-xs font-bold uppercase tracking-wider border ${status === k ? "bg-[#111827] text-white border-[#111827]" : "bg-white hover:border-zinc-500"}`}>{l}</button>)}</div>
      <div className="grid gap-3">
        {!items.length && <p className="text-sm text-zinc-500 bg-white border p-6 text-center" data-testid="comments-empty">Aucun commentaire.</p>}
        {items.map((c, i) => (
          <div key={c.id} data-testid={`comment-row-${i}`} className="bg-white border border-zinc-200 p-4 flex flex-col md:flex-row md:items-center gap-4">
            <div className="flex-1 min-w-0">
              <div className="text-xs text-zinc-500">Sur : <span className="font-semibold text-zinc-700">{c.article_title}</span> · {formatDate(c.created_at)}</div>
              <div className="font-bold mt-1">{c.name} {c.email && <span className="text-xs text-zinc-400 font-normal">({c.email})</span>}</div>
              <p className="text-sm text-zinc-700 mt-1">{c.content}</p>
            </div>
            <div className="flex gap-2 shrink-0">
              {c.status !== "approved" && <button data-testid={`comment-approve-${i}`} onClick={() => setS(c.id, "approved")} className="inline-flex items-center gap-1 bg-green-600 text-white px-3 py-2 text-xs font-bold uppercase hover:bg-green-700"><Check size={14} /> Approuver</button>}
              {c.status !== "rejected" && <button data-testid={`comment-reject-${i}`} onClick={() => setS(c.id, "rejected")} className="inline-flex items-center gap-1 border px-3 py-2 text-xs font-bold uppercase hover:bg-red-50 hover:text-red-600"><X size={14} /> Rejeter</button>}
              <button data-testid={`comment-delete-${i}`} onClick={() => del(c.id)} aria-label="Supprimer" className="p-2 border hover:bg-red-600 hover:text-white"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
